// Candle Anatomy correction line: one plain-language sentence per mistake,
// built from where the learner actually tapped and where the element really is
// (see core/revealModel.js), e.g.
//   "You marked the bottom of the body. Open belongs at the top of the body."
// Body and wick are regions rather than points, so they say what the region is.
export function correctionLine(m) {
  const you = `You marked ${m.yourPlace.long}.`;
  if (m.id === "body") return `${you} The body belongs between the open and the close.`;
  if (m.id === "wick") return `${you} A wick belongs above or below the body.`;
  return `${you} ${m.label} belongs at ${m.correctPlace.long}.`;
}
